<template>
  <div>
    <b-modal
      class="page-modal"
      hide-footer
      centered
      id="sim_card_pin_puk_modal"
      title="Récupérer mon code PUK"
        no-close-on-esc
      no-close-on-backdrop
    >
      <div class="text-center">
        <div class="modal-header-wrap">
          <i class="kgk-mtn-phonelink_lock modal-header-icon yellow-muted"></i>
          <h3>Code PUK</h3>
          <p class="text-muted">Veuillez cliquer sur le bouton ci dessous pour afficher votre code PUK.</p>
        </div>

        <div v-if="is_loading" style="width: 50%" class="mx-auto">
          <b-skeleton animation="wave" width="100%" height="30px"></b-skeleton>
        </div>
        <div
          class="red-color"
          v-if="!is_loading && puk != ''"
          id="puk_details"
        >
          {{ puk }}
        </div>

        <div v-if="!is_loading && puk == ''" class="mt-2 mb-2">
          <b-button variant="primary" @click="go()">Afficher</b-button>
        </div>
      </div>
      <div></div>
    </b-modal>
  </div>
</template>

<script>
import { subscriber } from "@/services/";
export default {
  name: "PinPuk",
  data: () => {
    return {
      is_loading: false,
      puk: "",
    };
  },
  methods: {
    go: async function () {
      this.is_loading = true;
      var puk = await subscriber.get_puk_and_puk();
      if (puk.success) {
        this.puk = this.get_puk(puk.response);
      }
      this.is_loading = false;
    },
    get_puk: function (msg) {
      var l = msg.split("est");
      if (_.isArray(l)) {
        return l[1];
      }
      return "";
    },
  },
};
</script>
<style scoped lang="css">
#puk_details {
  font-weight: bold;
  font-size: 32px;
  letter-spacing: 2px;
  padding: 0 30px 30px;
}
</style>